import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/payment-management/account-information')({
  component: () => <Outlet />,
});
